import { toast } from 'sonner';
import { config } from '@/config/environment';

export type ErrorSeverity = 'low' | 'medium' | 'high' | 'critical';

interface NotificationConfig {
  title: string;
  description?: string;
  severity: ErrorSeverity;
  persist?: boolean;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function showErrorNotification(config: NotificationConfig) {
  const { title, description, severity, persist, action } = config;
  
  const duration = persist || severity === 'critical' ? Infinity : getDurationBySeverity(severity);
  
  switch (severity) {
    case 'low':
      toast.info(title, {
        description,
        duration,
        action
      });
      break;
    case 'medium':
      toast.warning(title, {
        description,
        duration,
        action
      });
      break;
    case 'high':
    case 'critical':
      toast.error(title, {
        description,
        duration,
        action: action || (persist ? {
          label: "Dismiss",
          onClick: () => {}
        } : undefined)
      });
      break;
  }
}

function getDurationBySeverity(severity: ErrorSeverity): number {
  switch (severity) {
    case 'low':
      return 5000;
    case 'medium':
      return 7000;
    case 'high':
      return 8000;
    case 'critical':
      return Infinity;
    default:
      return 5000;
  }
}

export function showNetworkError(error: Error, retryFn?: () => void) {
  showErrorNotification({
    title: "Network Error",
    description: "Please check your connection and try again",
    severity: 'medium',
    action: retryFn ? {
      label: "Retry",
      onClick: retryFn
    } : undefined
  });
}

export function showValidationError(message: string) {
  showErrorNotification({
    title: "Validation Error",
    description: message,
    severity: 'low'
  });
}

export function showCriticalError(message: string, contactSupport = true) {
  showErrorNotification({
    title: "Critical Error",
    description: message,
    severity: 'critical',
    persist: true,
    action: contactSupport ? {
      label: "Contact Support",
      onClick: () => window.open(`mailto:${config.app.supportEmail}?subject=Critical Error`, '_blank')
    } : undefined
  });
}